import {useApi} from "../Api";

export const useEventRepository = () => {
    const {GET} = useApi();

    const PATH = "/pricing/event";

    function getCompleteProduct(productCodeId: string) {
        return GET(`${PATH}/send-rate-plan-complete-event?productCode=${productCodeId}`);
    }

    return {
        getCompleteProduct
    }

}
